import Wallboards from '../Wallboards/Wallboards';

const Settings = () => {

	return(<Wallboards
			logoutBtn={false}
		/>
	);
}

export default Settings
